export default __webpack_public_path__ + "static/media/alert-triangle-warning.63ba4012.svg";